import { makeStyles } from '@material-ui/core/styles';

export function useGuicheDeleteStyles() {
    const useStyles = makeStyles((theme) => ({
        button: {
            color: '#004B97',
            fontSize: '0.95rem',
            padding: '0.5rem 1rem',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
        cardHeader: {
            color: '#FFF',
            backgroundColor: '#004B97',
        },
        cardContent: {
            display: 'flex',
            flexDirection: 'column',
            marginLeft: theme.spacing(1),
            minWidth: 600,
        },
        cardActions: {
            justifyContent: "flex-end",
            borderTop: '1px solid #F0F0F0',
        },
        textWarning: {
            fontSize: '1rem',
            fontWeight: 400,
        },
        duplicateButton: {
            color: '#FFF',
            padding: '0.5rem 1rem',
            fontSize: '0.95rem',
            backgroundColor: '#004B97',
            '&:hover': {
                backgroundColor: '#003366',
            },
        },
    }));

    const classes = useStyles();

    return {
        classes,
    };
}
